import {
  CreatePaymentMethodDiscountRequest,
  PaymentMethodDiscount,
  PaymentMethodType,
  UpdatePaymentMethodDiscountRequest,
} from "../types/admin";
import { ApiResponse } from "../types/common";
import { withServiceFeeAlias } from "../utils/serviceFeePayload";

import apiClient from "./apiClient";

export const getPaymentMethodDiscounts = async (): Promise<
  ApiResponse<PaymentMethodDiscount[]>
> => {
  const response = await apiClient.get("/admin/payment-method-discounts");
  return response.data;
};

export const getPaymentMethodDiscountById = async (
  id: string
): Promise<ApiResponse<PaymentMethodDiscount>> => {
  const response = await apiClient.get(`/admin/payment-method-discounts/${id}`);
  return response.data;
};

export const createPaymentMethodDiscount = async (
  data: CreatePaymentMethodDiscountRequest
): Promise<ApiResponse<PaymentMethodDiscount>> => {
  const response = await apiClient.post(
    "/admin/payment-method-discounts",
    data
  );
  return response.data;
};

export const updatePaymentMethodDiscount = async (
  id: string,
  data: UpdatePaymentMethodDiscountRequest
): Promise<ApiResponse<PaymentMethodDiscount>> => {
  const response = await apiClient.put(
    `/admin/payment-method-discounts/${id}`,
    data
  );
  return response.data;
};

export const deletePaymentMethodDiscount = async (
  id: string
): Promise<ApiResponse<object>> => {
  const response = await apiClient.delete(
    `/admin/payment-method-discounts/${id}`
  );
  return response.data;
};

export const changePaymentMethodDiscountStatus = async (
  id: string,
  isActive: boolean
): Promise<ApiResponse<boolean>> => {
  const response = await apiClient.put(
    `/admin/payment-method-discounts/${id}/status?isActive=${isActive}`
  );
  return response.data;
};

// Public endpoint for checkout - get discount for payment method
export interface GetPaymentMethodDiscountRequest {
  paymentMethodType: PaymentMethodType;
  orderValue: number;
  fees: number;
  tax: number;
}

export interface PaymentMethodDiscountValidationResult {
  isValid: boolean;
  errorMessage?: string;
  discountAmount?: number;
  discount?: PaymentMethodDiscount;
}

export const getPaymentMethodDiscountForCheckout = async (
  data: GetPaymentMethodDiscountRequest
): Promise<ApiResponse<PaymentMethodDiscountValidationResult>> => {
  const response = await apiClient.post(
    "/Payment/payment-method-discount",
    withServiceFeeAlias(data)
  );
  return response.data;
};

// Get discounts for both Alif and DC Card at once
export interface GetAllPaymentMethodDiscountsRequest {
  orderValue: number;
  fees: number;
  tax: number;
}

export interface AllPaymentMethodDiscountsResponse {
  alifDiscount?: PaymentMethodDiscountValidationResult;
  dcCardDiscount?: PaymentMethodDiscountValidationResult;
}

export const getAllPaymentMethodDiscounts = async (
  data: GetAllPaymentMethodDiscountsRequest
): Promise<ApiResponse<AllPaymentMethodDiscountsResponse>> => {
  const response = await apiClient.post(
    "/Payment/payment-method-discounts/all",
    withServiceFeeAlias(data)
  );
  return response.data;
};
